/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import tzLookup from 'tz-lookup-oss';
import PropTypes from 'prop-types';
import Input from '../Input/Input';

import styles from './index.module.scss';

export class LocationSearchInput extends React.Component {
  constructor(props) {
    super(props);
    const { getFormState } = props;
    this.state = { address: getFormState('query', '') };
  }

  handleChange = (address) => {
    const { setFormState } = this.props;
    this.setState({ address });
    setFormState('query', address);
  };

  handleSelect = (address) => {
    const { handleSelectAddress } = this.props;
    geocodeByAddress(address)
      .then((results) => {
        const place = results[0];
        getLatLng(place).then((data) => {
          const tz = tzLookup(data.lat, data.lng);
          handleSelectAddress(place, tz);
        });
      })
      // eslint-disable-next-line no-console
      .catch((error) => console.error('Error', error));
  };

  render() {
    const { address } = this.state;
    const { label, classNameProp } = this.props;
    return (
      <PlacesAutocomplete
        value={address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
      >
        {({
          getInputProps, suggestions, getSuggestionItemProps, loading
        }) => (
          <div className={classNameProp}>
            <Input
              {...getInputProps({
                label,
              })}
            />
            <div className={styles.dropdown}>
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion) => {
                const className = suggestion.active
                  ? styles.active
                  : styles.suggestion;
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <div
                    key={suggestion.description}
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}

LocationSearchInput.propTypes = {
  handleSelectAddress: PropTypes.func,
  setFormState: PropTypes.func,
  getFormState: PropTypes.func,
  classNameProp: PropTypes.string,
  label: PropTypes.string
};
